const tracks = 
[
    {
        "src":  "MP3s/House Party Mix March 2026.mp3",
        "name":  "House Party Mix March 2026",
        "length":  "1h18m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix February 2026.mp3",
        "name":  "Deep House Mix February 2026",
        "length":  "1h11m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Hard House Mix February 2026.mp3",
        "name":  "Hard House Mix February 2026",
        "length":  "1h18m",
        "genre":  "Hard House"
    },
    {
        "src":  "MP3s/Classic House Mix February 2026.mp3",
        "name":  "Classic House Mix February 2026",
        "length":  "1h28m",
        "genre":  "Classic House"
    },
    {
        "src":  "MP3s/Deep House Mix January 2026.mp3",
        "name":  "Deep House Mix January 2026",
        "length":  "1h10m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Classic House Mix January 2026.mp3",
        "name":  "Classic House Mix January 2026",
        "length":  "1h20m",
        "genre":  "Classic House"
    },
    {
        "src":  "MP3s/House Mix December 2025.mp3",
        "name":  "House Mix December 2025",
        "length":  "1h13m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Hard House Mix November 2025.mp3",
        "name":  "Hard House Mix November 2025",
        "length":  "1h12m",
        "genre":  "Hard House"
    },
    {
        "src":  "MP3s/Drum \u0026 Bass Mix October 2025.mp3",
        "name":  "Drum \u0026 Bass Mix October 2025",
        "length":  "1h10m",
        "genre":  "Drum \u0026 Bass"
    },
    {
        "src":  "MP3s/Deep House Mix October 2025.mp3",
        "name":  "Deep House Mix October 2025",
        "length":  "1h11m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/House Mix September 2025.mp3",
        "name":  "House Mix September 2025",
        "length":  "1h04m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix September 2025.mp3",
        "name":  "Deep House Mix September 2025",
        "length":  "1h16m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Hard House Mix July 2025.mp3",
        "name":  "Hard House Mix July 2025",
        "length":  "1h22m",
        "genre":  "Hard House"
    },
    {
        "src":  "MP3s/Techno Mix June 2025.mp3",
        "name":  "Techno Mix June 2025",
        "length":  "1h09m",
        "genre":  "Techno"
    },
    {
        "src":  "MP3s/Deep House Mix May 2025.mp3",
        "name":  "Deep House Mix May 2025",
        "length":  "1h12m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Deep House Mix March 2025.mp3",
        "name":  "Deep House Mix March 2025",
        "length":  "1h12m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Deep House Mix February 2025.mp3",
        "name":  "Deep House Mix February 2025",
        "length":  "1h07m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/House Mix February 2025.mp3",
        "name":  "House Mix February 2025",
        "length":  "1h16m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix January 2025.mp3",
        "name":  "Deep House Mix January 2025",
        "length":  "1h20m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Deep House Mix December 2024.mp3",
        "name":  "Deep House Mix December 2024",
        "length":  "1h10m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Hard House Mix November 2024.mp3",
        "name":  "Hard House Mix November 2024",
        "length":  "1h15m",
        "genre":  "Hard House"
    },
    {
        "src":  "MP3s/House Mix November 2024.mp3",
        "name":  "House Mix November 2024",
        "length":  "1h15m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Techno Mix October 2024.mp3",
        "name":  "Techno Mix October 2024",
        "length":  "1h06m",
        "genre":  "Techno"
    },
    {
        "src":  "MP3s/House Party Mix October 2024.mp3",
        "name":  "House Party Mix October 2024",
        "length":  "1h03m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/House Mix September 2024.mp3",
        "name":  "House Mix September 2024",
        "length":  "1h04m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix September 2024.mp3",
        "name":  "Deep House Mix September 2024",
        "length":  "1h14m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/House Party Mix August 2024.mp3",
        "name":  "House Party Mix August 2024",
        "length":  "1h07m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix July 2024.mp3",
        "name":  "Deep House Mix July 2024",
        "length":  "1h14m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Techno Mix June 2024.mp3",
        "name":  "Techno Mix June 2024",
        "length":  "1h16m",
        "genre":  "Techno"
    },
    {
        "src":  "MP3s/Deep House Mix May 2024.mp3",
        "name":  "Deep House Mix May 2024",
        "length":  "1h11m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/House Mix April 2024.mp3",
        "name":  "House Mix April 2024",
        "length":  "1h19m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix April 2024.mp3",
        "name":  "Deep House Mix April 2024",
        "length":  "1h10m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Hard House Mix March 2024.mp3",
        "name":  "Hard House Mix March 2024",
        "length":  "1h04m",
        "genre":  "Hard House"
    },
    {
        "src":  "MP3s/Deep House Mix March 2024.mp3",
        "name":  "Deep House Mix March 2024",
        "length":  "1h13m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Techno Mix February 2024.mp3",
        "name":  "Techno Mix February 2024",
        "length":  "1h23m",
        "genre":  "Techno"
    },
    {
        "src":  "MP3s/House Party Mix February 2024.mp3",
        "name":  "House Party Mix February 2024",
        "length":  "1h08m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Tech House Mix January 2024.mp3",
        "name":  "Tech House Mix January 2024",
        "length":  "1h17m",
        "genre":  "Tech House"
    },
    {
        "src":  "MP3s/Deep House Mix January 2024.mp3",
        "name":  "Deep House Mix January 2024",
        "length":  "1h15m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/House Mix December 2023.mp3",
        "name":  "House Mix December 2023",
        "length":  "1h10m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Hardcore Rave Mix November 2023.mp3",
        "name":  "Hardcore Rave Mix November 2023",
        "length":  "1h26m",
        "genre":  "Hardcore"
    },
    {
        "src":  "MP3s/Deep House Mix November 2023.mp3",
        "name":  "Deep House Mix November 2023",
        "length":  "1h14m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Oldskool Jungle Mix November 2023.mp3",
        "name":  "Oldskool Jungle Mix November 2023",
        "length":  "0h55m",
        "genre":  "Jungle"
    },
    {
        "src":  "MP3s/House Party Mix November 2023.mp3",
        "name":  "House Party Mix November 2023",
        "length":  "1h16m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Techno Mix November 2023.mp3",
        "name":  "Techno Mix November 2023",
        "length":  "1h27m",
        "genre":  "Techno"
    },
    {
        "src":  "MP3s/House Party Mix September 2023.mp3",
        "name":  "House Party Mix September 2023",
        "length":  "1h18m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix August 2023.mp3",
        "name":  "Deep House Mix August 2023",
        "length":  "1h07m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Tech House Mix August 2023.mp3",
        "name":  "Tech House Mix August 2023",
        "length":  "1h02m",
        "genre":  "Tech House"
    },
    {
        "src":  "MP3s/UK Garage Mix July 2023.mp3",
        "name":  "UK Garage Mix July 2023",
        "length":  "1h04m",
        "genre":  "Garage"
    },
    {
        "src":  "MP3s/House Party Mix July 2023.mp3",
        "name":  "House Party Mix July 2023",
        "length":  "1h13m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Tech House Mix July 2023.mp3",
        "name":  "Tech House Mix July 2023",
        "length":  "1h10m",
        "genre":  "Tech House"
    },
    {
        "src":  "MP3s/Deep House Mix June 2023.mp3",
        "name":  "Deep House Mix June 2023",
        "length":  "1h23m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/House Party Mix June 2023.mp3",
        "name":  "House Party Mix June 2023",
        "length":  "1h13m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix May 2023.mp3",
        "name":  "Deep House Mix May 2023",
        "length":  "1h14m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Drum \u0026 Bass Mix May 2023.mp3",
        "name":  "Drum \u0026 Bass Mix May 2023",
        "length":  "1h33m",
        "genre":  "Drum \u0026 Bass"
    },
    {
        "src":  "MP3s/House Party Mix May 2023.mp3",
        "name":  "House Party Mix May 2023",
        "length":  "1h05m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Tech House Mix April 2023.mp3",
        "name":  "Tech House Mix April 2023",
        "length":  "1h11m",
        "genre":  "Tech House"
    },
    {
        "src":  "MP3s/Deep House Mix April 2023.mp3",
        "name":  "Deep House Mix April 2023",
        "length":  "1h24m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Techno Mix March 2023.mp3",
        "name":  "Techno Mix March 2023",
        "length":  "1h21m",
        "genre":  "Techno"
    },
    {
        "src":  "MP3s/Deep House Mix March 2023.mp3",
        "name":  "Deep House Mix March 2023",
        "length":  "1h25m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Drum \u0026 Bass Mix March 2023.mp3",
        "name":  "Drum \u0026 Bass Mix March 2023",
        "length":  "1h25m",
        "genre":  "Drum \u0026 Bass"
    },
    {
        "src":  "MP3s/House Party Mix March 2023.mp3",
        "name":  "House Party Mix March 2023",
        "length":  "1h17m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix February 2023.mp3",
        "name":  "Deep House Mix February 2023",
        "length":  "1h18m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/UK Garage Mix February 2023.mp3",
        "name":  "UK Garage Mix February 2023",
        "length":  "1h00m",
        "genre":  "Garage"
    },
    {
        "src":  "MP3s/Tech House Mix February 2023.mp3",
        "name":  "Tech House Mix February 2023",
        "length":  "1h25m",
        "genre":  "Tech House"
    },
    {
        "src":  "MP3s/House Party Mix January 2023.mp3",
        "name":  "House Party Mix January 2023",
        "length":  "1h19m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix January 2023.mp3",
        "name":  "Deep House Mix January 2023",
        "length":  "1h34m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Deep House Mix December 2022.mp3",
        "name":  "Deep House Mix December 2022",
        "length":  "1h19m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Techno Mix November 2022.mp3",
        "name":  "Techno Mix November 2022",
        "length":  "1h32m",
        "genre":  "Techno"
    },
    {
        "src":  "MP3s/House Party Mix November 2022.mp3",
        "name":  "House Party Mix November 2022",
        "length":  "1h12m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Tech House Mix November 2022.mp3",
        "name":  "Tech House Mix November 2022",
        "length":  "1h35m",
        "genre":  "Tech House"
    },
    {
        "src":  "MP3s/Deep House Mix November 2022.mp3",
        "name":  "Deep House Mix November 2022",
        "length":  "1h28m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/House Party Mix October 2022.mp3",
        "name":  "House Party Mix October 2022",
        "length":  "1h06m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Techno Mix October 2022.mp3",
        "name":  "Techno Mix October 2022",
        "length":  "1h28m",
        "genre":  "Techno"
    },
    {
        "src":  "MP3s/Deep House Mix October 2022.mp3",
        "name":  "Deep House Mix October 2022",
        "length":  "1h27m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/House Party Mix September 2022.mp3",
        "name":  "House Party Mix September 2022",
        "length":  "1h04m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Classic Piano House Mix September 2022.mp3",
        "name":  "Classic Piano House Mix September 2022",
        "length":  "1h45m",
        "genre":  "Classic House"
    },
    {
        "src":  "MP3s/Deep House Mix September 2022.mp3",
        "name":  "Deep House Mix September 2022",
        "length":  "1h18m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Tech House Mix August 2022.mp3",
        "name":  "Tech House Mix August 2022",
        "length":  "1h22m",
        "genre":  "Tech House"
    },
    {
        "src":  "MP3s/House Party Mix August 2022.mp3",
        "name":  "House Party Mix August 2022",
        "length":  "1h26m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix August 2022.mp3",
        "name":  "Deep House Mix August 2022",
        "length":  "1h23m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Deep House Mix July 2022.mp3",
        "name":  "Deep House Mix July 2022",
        "length":  "1h26m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/House Party Mix July 2022.mp3",
        "name":  "House Party Mix July 2022",
        "length":  "1h09m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Classic Piano House Mix July 2022.mp3",
        "name":  "Classic Piano House Mix July 2022",
        "length":  "1h39m",
        "genre":  "Classic House"
    },
    {
        "src":  "MP3s/Classic House Mix June 2022.mp3",
        "name":  "Classic House Mix June 2022",
        "length":  "1h25m",
        "genre":  "Classic House"
    },
    {
        "src":  "MP3s/House Party Mix June 2022.mp3",
        "name":  "House Party Mix June 2022",
        "length":  "1h09m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix June 2022.mp3",
        "name":  "Deep House Mix June 2022",
        "length":  "1h38m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Tech House Mix June 2022.mp3",
        "name":  "Tech House Mix June 2022",
        "length":  "1h28m",
        "genre":  "Tech House"
    },
    {
        "src":  "MP3s/Techno Mix June 2022.mp3",
        "name":  "Techno Mix June 2022",
        "length":  "1h23m",
        "genre":  "Techno"
    },
    {
        "src":  "MP3s/House Party Mix May 2022.mp3",
        "name":  "House Party Mix May 2022",
        "length":  "1h12m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Funky House Mix May 2022.mp3",
        "name":  "Funky House Mix May 2022",
        "length":  "1h35m",
        "genre":  "Funky House"
    },
    {
        "src":  "MP3s/Oldskool Hardcore Mix May 2022.mp3",
        "name":  "Oldskool Hardcore Mix May 2022",
        "length":  "1h35m",
        "genre":  "Hardcore"
    },
    {
        "src":  "MP3s/House Party Mix April 2022.mp3",
        "name":  "House Party Mix April 2022",
        "length":  "1h21m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/House Mix April 2022.mp3",
        "name":  "House Mix April 2022",
        "length":  "1h29m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix April 2022.mp3",
        "name":  "Deep House Mix April 2022",
        "length":  "1h32m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Techno Mix March 2022.mp3",
        "name":  "Techno Mix March 2022",
        "length":  "1h06m",
        "genre":  "Techno"
    },
    {
        "src":  "MP3s/House Party Mix March 2022.mp3",
        "name":  "House Party Mix March 2022",
        "length":  "1h15m",
        "genre":  "House"
    },
    {
        "src":  "MP3s/Deep House Mix March 2022.mp3",
        "name":  "Deep House Mix March 2022",
        "length":  "1h33m",
        "genre":  "Deep House"
    },
    {
        "src":  "MP3s/Classic Piano House Mix Feb 2022 [REMIXED].mp3",
        "name":  "Classic Piano House Mix Feb 2022",
        "length":  "1h39m",
        "genre":  "Classic House"
    }
];

export default tracks;